import { useDraggable } from "@dnd-kit/core";
import PropTypes from "prop-types";
import styles from './DragAndDrop.module.scss';

const SortableItem = ({
  nonRemovableTabs = [],
  tabs = [],
  item,
  id,
  category,
  name = "Item",
  severity = "",
  BackgroundColor,
  bordercolor = "black",
  changeFunc = () => {},
  isEditClicked = false,
  draggedObject = [],
  selectedTabs = [],
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useDraggable({
      id,
      disabled: !isEditClicked,
    });

  const getTagBgColor = (getColorCode) => {
    const tab = tabs.find((tab) => tab.name === getColorCode.sourceId);
    return tab ? tab.BackgroundColor : "black";
  };

  const getTagBordercolor = (getColorCode) => {
    const tab = tabs.find((tab) => tab.name === getColorCode.sourceId);
    return tab ? tab.Bordercolor : "black";
  };
  const getTagTextColor = (id) => {
    const draggedItem = draggedObject.find((dragged) => dragged.id === id);
    if (draggedItem) {
      const tab = tabs.find((tab) => tab.name === draggedItem.sourceId);
      return tab ? tab.Color : "black";
    } else {
      const tab = tabs.find((tab) => tab.name === category);
      return tab ? tab.Color : "black";
    }
  };

  const onRemove = () => {
    if (
      selectedTabs.includes("All") ||
      nonRemovableTabs.some((tab) => selectedTabs.includes(tab))
    ) {
      return changeFunc(id,category);
    }
    return null;
  };

  const getBackgroundColor = (id) => {
    const draggedItem = draggedObject.filter((dragged) => dragged.id == id);
    if (draggedItem.length > 0) {
      return getTagBgColor(draggedItem[0]);
    } else {
      return BackgroundColor;
    }
  };

  const getBorderColor = (id) => {
    const draggedItem = draggedObject.filter((dragged) => dragged.id == id);
    if (draggedItem.length > 0) {
      return getTagBordercolor(draggedItem[0]);
    } else {
      return bordercolor;
    }
  };

  const transformStyle = transform
    ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
    : undefined;

  const isNonRemovable = nonRemovableTabs.includes(category);
  const showRemoveIcon = !isNonRemovable && isEditClicked;
  return (
    <div
      ref={isEditClicked ? setNodeRef : null}
      {...(isEditClicked ? listeners : {})}
      {...attributes}
      className={`${styles.sortableItem} ${
       isEditClicked ? styles.grabCursor : styles.defaultCursor
      } ${transform ? styles.dragging : ""}`}
      style={{
        transform: transformStyle,
        transition,
        backgroundColor: getBackgroundColor(item.id),
        borderColor: getBorderColor(item.id),
        color: getTagTextColor(item.id),
        padding: nonRemovableTabs.includes(category)
          ? "5px 6px 5px 7px"
          : isEditClicked
          ? "6px 6px 6px 6px"
          : "5px 6px 5px 7px",
      }}
    >
      <span>
        {name}
        {showRemoveIcon && (
          <span onClick={onRemove} className={`${styles.cancelButton} visible`} >
            x
          </span>
        )}
      </span>
    </div>
  );
};

SortableItem.propTypes = {
  item: PropTypes.object,
  id: PropTypes.any,
  category: PropTypes.string,
  name: PropTypes.string,
  severity: PropTypes.string,
  bordercolor: PropTypes.string,
  BackgroundColor: PropTypes.string,
  changeFunc: PropTypes.array,
  nonRemovableTabs: PropTypes.func,
  isEditClicked: PropTypes.bool,
  draggedObject: PropTypes.array,
  selectedTabs: PropTypes.arrayOf(PropTypes.string),
  tabs: PropTypes.array,
};

export default SortableItem;



